var _filter, _filter2, _filter3, _pattern, _rect, _rect2, _rect3, _text, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgCluster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a0a14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#0f1029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#160a24"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "masterGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#eab308"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "workerGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#7c3aed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4c1d95"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "workerBody",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#120b2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coreActiveGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#047857"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reqGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0ea5e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#38bdf8"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glowSoft"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "shadow4"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 5,
    floodColor: "#000",
    floodOpacity: 0.4
  }))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 0.5,
    fill: "#334155",
    opacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    rx: 16,
    fill: "url(#bg4)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#dots)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    rx: 16,
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 1,
    opacity: 0.15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 35,
    textAnchor: "middle",
    fill: "#fcd34d",
    fontSize: 19,
    fontWeight: 700,
    opacity: 0
  }, "\n    Node.js Cluster Mode Architecture\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    fill: "freeze"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 65,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 11,
    letterSpacing: 2
  }, "INCOMING REQUESTS"), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 85,
    r: 14,
    fill: "#0c2d48",
    stroke: "#0ea5e9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 90,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 11
  }, "\uD83D\uDC64"), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 85,
    r: 14,
    fill: "#0c2d48",
    stroke: "#0ea5e9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 90,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 11
  }, "\uD83D\uDC64"), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 85,
    r: 14,
    fill: "#0c2d48",
    stroke: "#0ea5e9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 90,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 11
  }, "\uD83D\uDC64"), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 85,
    r: 14,
    fill: "#0c2d48",
    stroke: "#0ea5e9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 90,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 11
  }, "\uD83D\uDC64"), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 85,
    r: 14,
    fill: "#0c2d48",
    stroke: "#0ea5e9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 90,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 11
  }, "\uD83D\uDC64"), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    fill: "#38bdf8",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    from: 100,
    to: 130,
    dur: "0.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "240;300;360;400",
    dur: "0.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0.4;0",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    fill: "#38bdf8",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    from: 100,
    to: 130,
    dur: "0.9s",
    begin: "0.3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "480;450;420;400",
    dur: "0.9s",
    begin: "0.3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0.4;0",
    dur: "0.9s",
    begin: "0.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "#38bdf8",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    from: 100,
    to: 130,
    dur: "0.7s",
    begin: "0.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "320;350;380;400",
    dur: "0.7s",
    begin: "0.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;0.3;0",
    dur: "0.7s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    filter: "url(#shadow4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "0.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 120,
    width: 520,
    height: 70,
    rx: 14,
    fill: "#1a1508",
    stroke: "#f59e0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 120,
    width: 520,
    height: 30,
    rx: 14,
    fill: "url(#masterGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 138,
    width: 520,
    height: 12,
    fill: "url(#masterGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 142,
    textAnchor: "middle",
    fill: "#1a1508",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 1
  }, "\uD83D\uDC51  MASTER PROCESS"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 172,
    textAnchor: "middle",
    fill: "#fcd34d",
    fontSize: 12
  }, "Load Balancer \u2014 Distributes requests across workers (Round Robin)"), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 170,
    r: 4,
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 170,
    r: 7,
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 0.5,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "7;12;7",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0;0.3",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.4s",
    begin: "0.9s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 190,
    x2: 400,
    y2: 215,
    stroke: "#f59e0b",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 215,
    x2: 695,
    y2: 215,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 215,
    x2: 105,
    y2: 240,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 14,
    to: 0,
    dur: "0.7s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 215,
    x2: 300,
    y2: 240,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 14,
    to: 0,
    dur: "0.7s",
    begin: "0.1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 215,
    x2: 500,
    y2: 240,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 14,
    to: 0,
    dur: "0.7s",
    begin: "0.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 695,
    y1: 215,
    x2: 695,
    y2: 240,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 14,
    to: 0,
    dur: "0.7s",
    begin: "0.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "101,238 105,246 109,238",
    fill: "#f59e0b",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296,238 300,246 304,238",
    fill: "#f59e0b",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496,238 500,246 504,238",
    fill: "#f59e0b",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691,238 695,246 699,238",
    fill: "#f59e0b",
    opacity: 0.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    filter: "url(#shadow4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 248,
    width: 140,
    height: 115,
    rx: 12,
    fill: "url(#workerBody)",
    stroke: "#7c3aed",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 248,
    width: 140,
    height: 28,
    rx: 12,
    fill: "url(#workerGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 266,
    width: 140,
    height: 10,
    fill: "url(#workerGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 268,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 12,
    fontWeight: 700
  }, "Worker 1"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 300,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 11
  }, "\u2B22 Express App"), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 312,
    width: 90,
    height: 20,
    rx: 5,
    fill: "#0f0a20",
    stroke: "#4c1d95",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 326,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontFamily: "monospace"
  }, ":3000"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 352,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "PID: 2841"), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 260,
    r: 4,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.5s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    filter: "url(#shadow4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.3s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 248,
    width: 140,
    height: 115,
    rx: 12,
    fill: "url(#workerBody)",
    stroke: "#7c3aed",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 248,
    width: 140,
    height: 28,
    rx: 12,
    fill: "url(#workerGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 266,
    width: 140,
    height: 10,
    fill: "url(#workerGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 268,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 12,
    fontWeight: 700
  }, "Worker 2"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 300,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 11
  }, "\u2B22 Express App"), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 312,
    width: 90,
    height: 20,
    rx: 5,
    fill: "#0f0a20",
    stroke: "#4c1d95",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 326,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontFamily: "monospace"
  }, ":3000"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 352,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "PID: 2842"), /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 260,
    r: 4,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.8s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 248,
    width: 140,
    height: 115,
    rx: 12,
    fill: "url(#workerBody)",
    stroke: "#7c3aed",
    strokeWidth: 1,
    strokeDasharray: "6,4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 295,
    textAnchor: "middle",
    fill: "#7c3aed",
    fontSize: 28,
    fontWeight: 300
  }, "\xB7 \xB7 \xB7"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 330,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 11
  }, "More Workers"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 348,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10
  }, "(up to N CPUs)"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    filter: "url(#shadow4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.7s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 248,
    width: 140,
    height: 115,
    rx: 12,
    fill: "url(#workerBody)",
    stroke: "#7c3aed",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 248,
    width: 140,
    height: 28,
    rx: 12,
    fill: "url(#workerGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 266,
    width: 140,
    height: 10,
    fill: "url(#workerGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 268,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 12,
    fontWeight: 700
  }, "Worker 16"), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 300,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 11
  }, "\u2B22 Express App"), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 312,
    width: 90,
    height: 20,
    rx: 5,
    fill: "#0f0a20",
    stroke: "#4c1d95",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 326,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontFamily: "monospace"
  }, ":3000"), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 352,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "PID: 2856"), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 260,
    r: 4,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.2s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.4s",
    begin: "2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 385,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    letterSpacing: 1.5
  }, "MAPPED TO CPU CORES"), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 363,
    x2: 105,
    y2: 405,
    stroke: "#10b981",
    strokeWidth: 1.5,
    strokeDasharray: "3,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 12,
    to: 0,
    dur: "0.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 363,
    x2: 300,
    y2: 405,
    stroke: "#10b981",
    strokeWidth: 1.5,
    strokeDasharray: "3,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 12,
    to: 0,
    dur: "0.6s",
    begin: "0.1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 363,
    x2: 500,
    y2: 405,
    stroke: "#10b981",
    strokeWidth: 1.5,
    strokeDasharray: "3,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 12,
    to: 0,
    dur: "0.6s",
    begin: "0.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 695,
    y1: 363,
    x2: 695,
    y2: 405,
    stroke: "#10b981",
    strokeWidth: 1.5,
    strokeDasharray: "3,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 12,
    to: 0,
    dur: "0.6s",
    begin: "0.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "101,403 105,411 109,403",
    fill: "#10b981",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296,403 300,411 304,403",
    fill: "#10b981",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496,403 500,411 504,403",
    fill: "#10b981",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691,403 695,411 699,403",
    fill: "#10b981",
    opacity: 0.7
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "2.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 415,
    width: 130,
    height: 48,
    rx: 10,
    fill: "#071f14",
    stroke: "#10b981",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 415,
    width: 130,
    height: 48,
    rx: 10,
    fill: "url(#coreActiveGrad)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.25;0.1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 436,
    fill: "#10b981",
    fontSize: 16
  }, "\u2699\uFE0F"), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 436,
    fill: "#6ee7b7",
    fontSize: 12,
    fontWeight: 700
  }, "Core 0"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 454,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 10,
    fontWeight: 600
  }, "ACTIVE"), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 457,
    width: 0,
    height: 3,
    rx: 1.5,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "40;90;60;80;40",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 415,
    width: 130,
    height: 48,
    rx: 10,
    fill: "#071f14",
    stroke: "#10b981",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 415,
    width: 130,
    height: 48,
    rx: 10,
    fill: "url(#coreActiveGrad)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.25;0.1",
    dur: "2.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 285,
    y: 436,
    fill: "#10b981",
    fontSize: 16
  }, "\u2699\uFE0F"), /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 436,
    fill: "#6ee7b7",
    fontSize: 12,
    fontWeight: 700
  }, "Core 1"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 454,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 10,
    fontWeight: 600
  }, "ACTIVE"), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 457,
    width: 0,
    height: 3,
    rx: 1.5,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "70;40;85;50;70",
    dur: "3.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 415,
    width: 130,
    height: 48,
    rx: 10,
    fill: "#071f14",
    stroke: "#10b981",
    strokeWidth: 1,
    strokeDasharray: "5,3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 440,
    textAnchor: "middle",
    fill: "#10b981",
    fontSize: 14
  }, "\xB7 \xB7 \xB7"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 456,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 10,
    fontWeight: 600
  }, "ACTIVE"), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 415,
    width: 130,
    height: 48,
    rx: 10,
    fill: "#071f14",
    stroke: "#10b981",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 415,
    width: 130,
    height: 48,
    rx: 10,
    fill: "url(#coreActiveGrad)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.25;0.1",
    dur: "1.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 436,
    fill: "#10b981",
    fontSize: 16
  }, "\u2699\uFE0F"), /*#__PURE__*/React.createElement("text", {
    x: 705,
    y: 436,
    fill: "#6ee7b7",
    fontSize: 12,
    fontWeight: 700
  }, "Core 15"), /*#__PURE__*/React.createElement("text", {
    x: 695,
    y: 454,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 10,
    fontWeight: 600
  }, "ACTIVE"), /*#__PURE__*/React.createElement("rect", {
    x: 645,
    y: 457,
    width: 0,
    height: 3,
    rx: 1.5,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "55;85;40;70;55",
    dur: "2.7s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "2.6s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 485,
    width: 700,
    height: 95,
    rx: 14,
    fill: "#060f09",
    stroke: "#22c55e",
    strokeWidth: 1.5,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 502,
    width: 170,
    height: 60,
    rx: 10,
    fill: "#1a0808",
    stroke: "#ef4444",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 522,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontWeight: 600
  }, "BEFORE (Single Thread)"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 548,
    textAnchor: "middle",
    fill: "#fca5a5",
    fontSize: 20,
    fontWeight: 800
  }, "10,835"), /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 548,
    fill: "#ef4444",
    fontSize: 10
  }, "RPS"), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 532,
    x2: 310,
    y2: 532,
    stroke: "#f59e0b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    values: "290;310;290",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "305,527 315,532 305,537",
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "points",
    values: "300,527 310,532 300,537;305,527 315,532 305,537;300,527 310,532 300,537",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 502,
    width: 170,
    height: 60,
    rx: 10,
    fill: "#0a0a1a",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 522,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 10,
    fontWeight: 600
  }, "WITH CLUSTERING"), /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 548,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontSize: 20,
    fontWeight: 800
  }, "52,588"), /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 548,
    fill: "#818cf8",
    fontSize: 10
  }, "RPS"), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 510,
    width: 35,
    height: 18,
    rx: 9,
    fill: "#f59e0b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 523,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 10,
    fontWeight: 800
  }, "4.8x"), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 502,
    width: 170,
    height: 60,
    rx: 10,
    fill: "#071a0f",
    stroke: "#22c55e",
    strokeWidth: 1.5,
    filter: "url(#glow4)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 645,
    y: 522,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 10,
    fontWeight: 600
  }, "\u2705 ALL 16 CORES ACTIVE"), /*#__PURE__*/React.createElement("text", {
    x: 645,
    y: 548,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 20,
    fontWeight: 800
  }, "~80%"), /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 548,
    fill: "#22c55e",
    fontSize: 10
  }, "CPU"), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 515,
    r: 2,
    fill: "#4ade80"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1;3;1",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 530,
    r: 2,
    fill: "#4ade80"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1;3;1",
    dur: "2.5s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "2.5s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCluster);
export default __webpack_public_path__ + "static/media/svg-cluster.0cac622645fcd244077d74616b3babc5.svg";
export { ForwardRef as ReactComponent };